import BaseButton from "./BaseButton";
import { Sounds } from "../../types/Enum";
import { ButtonBounds } from "../../types/Interface";


export default class PrizeChartButton extends BaseButton {

  constructor(bounds: ButtonBounds) {
    super("prize_chart",Sounds.click1);
    Object.assign(this, bounds);
    this.anchor.set(.5);
  }
}